import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText
} from 'reactstrap';
import { getProductAddonList } from '../../actions/productAddonAction';
import privateView from '../../components/hocs/privateView';
import { CardHeaderWithToolbars, Title } from '../../components/Card/CardHeaderWithToolbars';
import { FontAwesomeIcon } from '../../components/Icons';
import Paginations from '../../components/Paginations';
import PaginationSummaries from '../../components/Paginations/PaginationSummaries';
import { Tbl, TblHead, TblBody } from '../../components/Tbl';
import { generateNumber } from '../../utils';
import { Toolbars, Filters } from './Filters'
import { DEFAULT_SORT_BY, DEFAULT_PER_PAGE } from '../../constants/settings';
import RowItem from './productAddonIndex/RowItem';
import Analytics from "../../services/Analytics";

const dataHeader=[
	'No.', 'Name', 'Price', 'Active', 'Updated', 'Action'
];

const defaultParams = {
  keyword: '',
  sort_by : DEFAULT_SORT_BY,
  // per_page : 1
  per_page : DEFAULT_PER_PAGE
}
class ProductAddonIndex extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      _params:{
        ...defaultParams
      },
      _filterOpen: false
    }
  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    this._getList(this.state._params);
    Analytics.recordPageView('product_addons_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _getList(rawParams = {}){
    const params = Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .reduce((obj, current)=> ({...obj, [current]: rawParams[current]}), []);
    this.props.getList({params});
  }

  _handleRefresh = (e) => {
    e.preventDefault();
    this._refreshList();
  }

  _refreshList = () => {
    const { _page, ..._params } = this.state._params;
    this.setState({
      _params
    },()=>this._getList(this.state._params));
  }

  _handleToggleFilterPanel = () =>{
    this.setState({_filterOpen: !this.state._filterOpen})
  }

  _handleApplyFilter = p => {
    const { _params } = this.state;
    this.setState({
      _params: {
        ..._params,
        ...p,
        page: 1
      }
    }, () => {
      this._getList(this.state._params)
    })
  }

  _handleResetFilter = (e) =>{
    e.preventDefault();
    this.setState({
      _params:{
        ...defaultParams
      },
      _filterOpen: false
    }, () => {
      this._getList(this.state._params)
    })
  }

	_handleGoto = page =>{
    this.setState({
      _params: {
        ...this.state._params,
        page
      }
    }, ()=> this._getList(this.state._params) );
  }

  render(){
    return(
      <div className="animated fadeIn">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <FontAwesomeIcon iconType="align-justify"/>{' '}
                  <span>Product Addon List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <Filters
                {...this.state._params}
                onApplyFilter={this._handleApplyFilter}
                isOpen={this.state._filterOpen}
              />
              <CardBody>
                <CardText>
                  In this section will display our product-addons.
                </CardText>
                <PaginationSummaries
                  from={this.props.dataProductAddon.data.from}
                  to={this.props.dataProductAddon.data.to}
                  total={this.props.dataProductAddon.data.total}
                />
                <div className="table-responsive" ref={tableRef => this.tableRef = tableRef}>
                  <Tbl>
                    <TblHead
                      dataHeader={dataHeader}
                    />
                    <TblBody
                      isLoad={this.props.dataProductAddon.isFetch}
                      hasRow={this.props.dataProductAddon.status_code===200&&this.props.dataProductAddon.data.data.length>0}
                      columnCount={dataHeader.length}
                      renderChildren={() =>{
                        const { current_page, per_page, data } =  this.props.dataProductAddon.data;
                        return data.map((item, key)=> {
                          const rowNumber = generateNumber(per_page,current_page,key);
                          return(
                            <RowItem
                              key={item.id}
                              rowNumber={rowNumber}
                              {...item}
                            />
                          )
                        })
                      }}
                    />
                  </Tbl>
                </div>
                { this.props.dataProductAddon.status_code===200 && (
                  <Paginations
                    size="sm"
                    lastPage={this.props.dataProductAddon.data.last_page}
                    perPage={this.props.dataProductAddon.data.per_page}
                    total={this.props.dataProductAddon.data.total}
                    maxPage={8}
                    path={this.props.dataProductAddon.data.path}
                    currentPage={this.props.dataProductAddon.data.current_page}
                    prevPageUrl={this.props.dataProductAddon.data.prev_page_url}
                    nextPageUrl={this.props.dataProductAddon.data.next_page_url}
                    handleGotoCallback={this._handleGoto}
                    onCurrentPageChanged={() => {
                      window.scrollTo({
                        top: this.tableRef.offsetTop+25,
                        behavior: 'smooth'
                      })
                    }}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps= ({ productAddon, auth: { isFetch, roles, isLogged, id, email } }) => ({
  guardData: { isFetch, roles, isLogged, id, email },
  dataProductAddon: productAddon.list
});

const mapDispatchToProps = (dispatch) => ({
  getList:(query) => dispatch(getProductAddonList(query))
});

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(privateView(ProductAddonIndex, ['supervisor', 'sale_supervisor']));